import { combineReducers } from 'redux';
import Homes from './Homes/reducer';
import Boxes from './Boxes/reducer';
import Brands from './Brands/reducer';
import Craftsmen from './Craftsman/reducer';
import UsersManagers from './UsersManagers/reducer';
import TicketFhe from './TicketFhe/reducer';
import Products from './Products/reducer';
import Managements from './Managements/reducer';
import Issues from './Issues/reducer';
import Projects from './Projects/reducer';
import Users from './Users/reducer';

export default env => {
    return combineReducers({
        Homes: (...props) => Homes(env, ...props),
        Boxes: (...props) => Boxes(env, ...props),
        Brands: (...props) => Brands(env, ...props),
        Craftsmen: (...props) => Craftsmen(env, ...props),
        UsersManagers: (...props) => UsersManagers(env, ...props),
        TicketFhe: (...props) => TicketFhe(env, ...props),
        Products: (...props) => Products(env, ...props),
        Managements: (...props) => Managements(env, ...props),
        Issues: (...props) => Issues(env, ...props),
        Projects: (...props) => Projects(env, ...props),
        Users: (...props) => Users(env, ...props)
    });
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/reducer.js